export default {"src":"/_next/static/media/share_dots.7ac10a27.svg","height":26,"width":25,"blurWidth":0,"blurHeight":0};